import { render, staticRenderFns } from "./StaticLayout.vue?vue&type=template&id=b2c2b566&scoped=true&"
import script from "./StaticLayout.vue?vue&type=script&lang=js&"
export * from "./StaticLayout.vue?vue&type=script&lang=js&"
import style0 from "./StaticLayout.vue?vue&type=style&index=0&id=b2c2b566&scoped=true&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b2c2b566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
